import React,  {Component, Fragment} from "react";
import {useTranslation} from "react-i18next";

import ValTab from "./valtab";

function Risks({data, onUpdate, simplified}) {

    const {t} = useTranslation();

    var headerStyle = {width: 60, maxWidth: 60, padding: 3, fontSize: "60%"};

    return <ValTab
            title={t("Incompatible Risks")}
            columns={[
                {title: t("Type 1"), field: "type1", type: "numeric", min:1, required: true, width: 60, headerStyle: headerStyle},
                {title: t("Type 2"), field: "type2", type: "numeric", min:1, required: true, width: 60, headerStyle: headerStyle}
                ]}
            data={data}
            onUpdate={onUpdate}
            />;
    }


export default Risks;